export default "__VITE_ASSET__BNe9SKvL__";